export default __webpack_public_path__ + "static/media/letsfika.fd6d2cac.jpg";